/**
 * HomeIntro - Visible H1 + short intro paragraph for SEO
 * Designed minimalist to not break the existing visual flow.
 * Targets the brand keyword "תכשיטי אליס" naturally.
 */
const HomeIntro = () => {
  return (
    <section
      className="sr-only"
      aria-labelledby="home-intro-heading"
    >
      <div>
        <h1
          id="home-intro-heading"
          className="text-2xl md:text-3xl text-foreground mb-4"
          style={{ fontWeight: 300, letterSpacing: '0.02em' }}
        >
          תכשיטי אליס - תכשיטים ושעונים בבאר שבע
        </h1>
        <div className="w-12 h-px bg-primary/40 mx-auto mb-5"></div>
        <p
          className="text-sm md:text-base text-muted-foreground leading-relaxed"
          style={{ fontWeight: 300 }}
        >
          ברוכים הבאים ל<strong className="font-normal text-foreground">תכשיטי אליס</strong> -
          חנות התכשיטים המובילה בבאר שבע מאז 1984. אצל
          <strong className="font-normal text-foreground"> אליס תכשיטים</strong> תמצאו מבחר ענק
          של טבעות אירוסין, שרשראות זהב, צמידים, עגילים ושעוני יוקרה - הכל תחת קורת גג אחת,
          באיכות הגבוהה ביותר ובאחריות מלאה.
        </p>
      </div>
    </section>
  );
};

export default HomeIntro;
